import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilSpeedometer, cilBook,cilGroup,cilQrCode, cilText

} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'

const _nav = [
  {
    component: CNavItem,
    name: 'Projects',
    to: '/projects', // Specify the correct route
    icon: <CIcon icon={cilBook} customClassName="nav-icon" />,
    // Optional: Add a badge if needed
    // badge: {
    //   color: 'info', // Or any other color
    // },
  },
  {
    component: CNavItem,
    name: 'Assessments',
    to: '/assessments',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    roles: ['org-admin', 'org-survey-analyst','org-viewer','org-enabler-super-admin'],
    badge: {
      color: 'info',
    },
  },
  {
    component: CNavItem,
    name: 'Qrcode', // New component for "Groups"
    to: '/groups', // Specify the route for "Groups"
    icon: <CIcon icon={cilQrCode} customClassName="nav-icon"/>, 
    roles: ['instance-manager']// Use an appropriate icon
  },
]

export default _nav
